/* @flow */

import React from 'react';
import ReactDOM from 'react-dom';
import { AppContainer } from 'react-hot-loader';
import configureStore from './store';
import { createBrowserHistory } from 'history';
import Root from './containers/Root';

export const index = () => {
  const root = document.getElementById('root');

  const history = createBrowserHistory({
    basename: '/mc/messaging',
  });

  const store = configureStore(history);
  const render = App => {
    ReactDOM.render(
      <AppContainer>
        <App store={store} history={history} />
      </AppContainer>,
      root
    );
  };

  render(Root);

  // Hot Module Replacement API
  if (module.hot) {
    module.hot.accept('./containers/Root', () => {
      const NextRoot = require('./containers/Root').default;
      render(NextRoot);
    });
  }
};



// WEBPACK FOOTER //
// ./src/modules/messaging/index.js